const elements = {
	menuOverlay: document.querySelector("#menu-overlay"),
	miniCart: document.getElementById("mini-cart"),
	miniCartToggles: Array.from(
		document.querySelectorAll("button.mini-cart-toggle")
	),
	miniCartCount: document.querySelector("#mini-cart-count"),
	navbarCartButton: document.querySelector("#cart-button"),
	menuControls: document.querySelector("#navbar .menu-controls"),
};

const fragmentSanitizer = {
	allowedTags: ["ul", "li", "div", "a", "img", "h2", "span", "p", "strong"],
	allowedAttributes: {
		a: [
			"href",
			"class",
			"aria-label",
			"data-product_id",
			"data-cart_item_key",
			"data-product_sku",
		],
		img: [
			"width",
			"height",
			"src",
			"class",
			"alt",
			"decoding",
			"data-has-transparency",
			"data-dominant-color",
			"style",
			"fetchpriority",
		],
		h2: ["class"],
		span: ["class"],
		p: ["class"],
		div: ["class"],
		ul: ["class"],
		li: ["class"],
	},
};

function toggleCartButton() {
	const count = parseInt(elements.miniCartCount.textContent);
	if (count) {
		elements.navbarCartButton.setAttribute("aria-hidden", "false");
		return;
	}
	elements.navbarCartButton.setAttribute("aria-hidden", "true");
}

const toggleMenu = () => {
	const ariaExpanded = elements.miniCart.getAttribute("aria-expanded");
	document.body.classList.toggle("no-scroll", ariaExpanded === "false");
	elements.menuOverlay.classList.toggle("menu-exited", ariaExpanded === "true");
	if (ariaExpanded === "false") {
		elements.miniCart.setAttribute("aria-expanded", "true");
		return;
	}
	elements.miniCart.setAttribute("aria-expanded", "false");
};

elements.miniCartToggles.map((miniCartToggle) => {
	miniCartToggle.addEventListener("click", toggleMenu);
});

jQuery(document).ready(function ($) {
	$(document.body).on("removed_from_cart", () => {
		$(document.body).trigger("wc_fragment_refresh");
		toggleCartButton();
	});

	$(document.body).on("added_to_cart", () => {
		$(document.body).trigger("wc_fragment_refresh");
		toggleCartButton();
		toggleMenu();
	});
});
